import classNames from "classnames";
import React, { useEffect } from "react";
import { Image as ImageComp, initCustomElement } from "./../../bundled-dependencies/wix-image.js";
import styles from "./Image-scss.js";
import { MediaItemErrorMsg } from "./media-item-error-msg.js";
let wixImageInitialized = false;
const Image = (props) => {
  if (!wixImageInitialized) {
    initCustomElement();
    wixImageInitialized = true;
  }
  const { containerProps, error, shouldUseLQIP: shouldUseLQIPProp = true, ...imageProps } = props;
  const [isPrinting, setIsPrinting] = React.useState(false);
  useEffect(() => {
    const handleBeforePrint = () => {
      setIsPrinting(true);
    };
    window.addEventListener("beforeprint", handleBeforePrint);
    return () => {
      window.removeEventListener("beforeprint", handleBeforePrint);
    };
  }, []);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      style: containerProps?.style,
      id: containerProps?.containerId,
      className: containerProps?.className,
      "data-hook": containerProps?.dataHook
    },
    /* @__PURE__ */ React.createElement(
      ImageComp,
      {
        ...imageProps,
        alignType: "center",
        className: classNames(styles.image, imageProps.className),
        shouldUseLQIP: shouldUseLQIPProp && !isPrinting
      }
    ),
    error && /* @__PURE__ */ React.createElement(MediaItemErrorMsg, { error: error.message, t: error.t })
  );
};
export {
  Image
};
//# sourceMappingURL=image.js.map
